import React from "react";
import { Route } from "react-router-dom";
import DashboardLayout from "@/components/DashboardLayout";
import { Protected } from "./Protected";

import Admin from "@/pages/Admin";
import AdminIntegrations from "@/pages/AdminIntegrations";
import AdminCustomers from "@/pages/AdminCustomers";
import AdminPlans from "@/pages/AdminPlans";
import AdminMagic from "@/pages/AdminMagic";
import ApprovalQueue from "@/pages/ApprovalQueue";
import Support from "@/pages/Support";

const admin = (Page) => (
  <Protected adminOnly requireOnboarded={false}>
    <DashboardLayout><Page /></DashboardLayout>
  </Protected>
);

export const AdminRoutes = (
  <>
    <Route path="/admin" element={admin(Admin)} />
    <Route path="/admin/customers" element={admin(AdminCustomers)} />
    <Route path="/admin/plans" element={admin(AdminPlans)} />
    <Route path="/admin/magic" element={admin(AdminMagic)} />
    <Route path="/admin/integrations" element={admin(AdminIntegrations)} />
    <Route path="/admin/approvals" element={admin(ApprovalQueue)} />
    <Route path="/admin/tickets" element={admin(Support)} />
  </>
);
